import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { bgLinearGradient } from "@/app/types/ui";
import { LoginForm } from "@/components/login/LoginForm";
import { HeadingOne } from "@/components/ui/typography/HeadingOne";
import { Paragraph } from "@/components/ui/typography/Paragraph";
import { MimiatHorizontalLogo } from "@/components/shared/MimiatHorizonalLogo";
import { LanguageSelector } from "@/components/shared/LanguageSelector";

import loginImg from "@/assets/login/login-img.png";

export const Route = createFileRoute("/login/")({
  component: LoginPage,
});

function LoginPage() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-5 min-h-screen overflow-hidden">
      {/* Image */}
      <div className="grid col-span-2 bg-beige self-center overflow-hidden">
        <img src={loginImg} alt="Login img" />
      </div>

      {/* Login Form */}
      <div
        className={`grid col-span-3 ${bgLinearGradient} border-l-1 border-neutral-500 overflow-y-auto h-screen`}
      >
        <div>
          <div className="my-8 flex justify-end mx-24 2xl:max-w-3xl 2xl:mx-auto">
            <LanguageSelector />
          </div>
          <div className="flex flex-col my-auto h-5/6 justify-center">
            <div className="mx-auto mb-8">
              <MimiatHorizontalLogo />
            </div>
            <div className="mx-24 2xl:min-w-[575px] 2xl:mx-auto mb-12">
              <div className="flex flex-col gap-2 mb-4">
                <HeadingOne>{t("login.title")}</HeadingOne>
                <Paragraph>{t("login.subtitle")}</Paragraph>
              </div>
              <LoginForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
